import { render, staticRenderFns } from "./CreateInfectionCase.vue?vue&type=template&id=44d7f98e&"
import script from "./CreateInfectionCase.vue?vue&type=script&lang=js&"
export * from "./CreateInfectionCase.vue?vue&type=script&lang=js&"
import style0 from "./CreateInfectionCase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports